import { useEffect, useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { CtaButton, handleCta } from "./primitives";

export default function MobileStickyCta() {
  const [show, setShow] = useState(false);

  useEffect(() => {
    const onScroll = () => setShow(window.scrollY > 700);
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <AnimatePresence>
      {show && (
        <motion.div
          initial={{ y: 100, opacity: 0 }}
          animate={{ y: 0, opacity: 1 }}
          exit={{ y: 100, opacity: 0 }}
          transition={{ duration: 0.4, ease: [0.16, 1, 0.3, 1] }}
          className="fixed inset-x-0 bottom-0 z-50 border-t border-brand-navy/10 glass-nav p-3 lg:hidden"
        >
          <CtaButton
            size="md"
            className="w-full"
            onClick={() => handleCta("checkout")}
            data-testid="mobile-sticky-cta"
          >
            QUERO ME PREPARAR PARA A UNESP
          </CtaButton>
        </motion.div>
      )}
    </AnimatePresence>
  );
}
